import React from 'react';
import { connect } from 'react-redux';
import cx from 'classnames';
import PropTypes from 'prop-types';
import T from 'i18n-react';
import TextField from '@material-ui/core/TextField';
import { withStyles } from '@material-ui/core/styles/index';
import { actAnyFieldUpdate, getValue } from 'actions/formActions';
import NumberFormat from 'react-number-format';

const FloatField = (props) => {
  const { inputRef, onChange, ...other } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={(values) => {
        onChange({
          target: {
            value: values.value,
          },
        });
      }}
    />
  );
};

const IntegerField = (props) => {
  const { inputRef, onChange, ...other } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={(values) => {
        onChange({
          target: {
            value: values.value,
          },
        });
      }}
    />
  );
};

const styles = (theme) => ({
  root: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing.unit,
    '& input[type=number]::-webkit-inner-spin-button,& input[type=number]::-webkit-outer-spin-button': {
      WebkitAppearance: 'none',
      margin: 0,
    },
    '& input[type=number]': {
      MozAppearance: 'textfield',
    },
  },
  FormField: {
    marginTop: '10px',
    width: '100%',
    fontWeight: 'normal !important',
    fontSize: '16px !important',
    '& label, input': {
      paddingLeft: '10px',
      paddingRight: '10px',
    },
  },
  fourFifthFormField: {
    marginTop: '10px',
    width: '80%',
  },
  ReadOnlyFormField: {
    width: '100%',
    '& label, input, textarea': {
      color: '#000',
    },
    '& :before': {
      borderBottom: '0',
    },
  },
  inline: {
    display: 'inline',
  },
  labelDiv: {
    display: 'flex',
  },
  mandatory: {
    fontSize: '20px',
    color: 'red',
    marginRight: '10px',
  },
});

const FormField = (props) => {
  const {
    classes,
    storeName,
    accessPath,
    fieldName,
    noLabel,
    error,
    type,
    helper,
    inline,
    mandatory,
    multiline,
    onChange,
    onFieldUpdate,
    inputStyle,
    rows,
    valueMapping,
    onKeyPress,
    placeholder,
    InputProps,
    InputLabelProps,
    newAccessPath,
    dataType,
    disabled, // for withStatus
  } = props;

  const formClasses = cx(classes.root, {
    [classes.inline]: inline,
    [classes.FormField]: !disabled,
    [classes.ReadOnlyFormField]: disabled,
  });

  function myHelperText() {
    if (error) {
      return error;
    }
    if (helper) {
      return T.translate(`${storeName}.helper.${accessPath[accessPath.length - 1]}`);
    }
    return null;
  }

  function myUpdateFunc(e) {
    if (onChange) {
      onChange(e.target.value);
    }
    if (newAccessPath) {
      onFieldUpdate(storeName, newAccessPath, e.target.value);
    }
    onFieldUpdate(storeName, accessPath, e.target.value);
  }

  function myValue() {
    const v = getValue(props[storeName].data, accessPath);

    if (v == null) return '';

    return valueMapping ? valueMapping(v) : v;
  }

  let inputProps = InputProps;

  if (dataType === 'integer') {
    inputProps = { inputComponent: IntegerField };
  } else if (dataType === 'float') {
    inputProps = { inputComponent: FloatField };
  }

  return (
    <TextField
      error={error != null}
      type={type}
      rows={rows}
      rowsMax={rows}
      multiline={multiline}
      disabled={disabled}
      label={
        noLabel ? (
          ''
        ) : !fieldName ? (
          <div className={classes.labelDiv}>
            {mandatory ? <div className={classes.mandatory}>*</div> : null}
            {T.translate(`${storeName}.${accessPath[accessPath.length - 1]}`)}
          </div>
        ) : (
          <div className={classes.labelDiv}>
            {mandatory ? <div className={classes.mandatory}>*</div> : null}
            {T.translate(`${storeName}.${fieldName}`)}
          </div>
        )
      }
      className={formClasses}
      value={myValue()}
      onChange={myUpdateFunc}
      helperText={myHelperText()}
      style={inputStyle}
      margin='normal'
      onKeyPress={onKeyPress || null}
      placeholder={placeholder}
      InputLabelProps={InputLabelProps}
      InputProps={inputProps}
    />
  );
};

FormField.propTypes = {
  classes: PropTypes.object.isRequired,
  storeName: PropTypes.string.isRequired,
  accessPath: PropTypes.array.isRequired,
  helper: PropTypes.bool,
  noEdit: PropTypes.bool,
  valueMapping: PropTypes.func,
};

const mapStateToProps = (state) => state;

const mapDispatchToProps = (dispatch) => ({
  onFieldUpdate: (storeName, accessPath, newVal) => {
    dispatch(actAnyFieldUpdate(storeName, accessPath, newVal));
  },
});

const FormFieldContainer = connect(mapStateToProps, mapDispatchToProps)(FormField);

export default withStyles(styles)(FormFieldContainer);
